export const SET_TEACHERS = 'setTeachers'
